<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">Países</h1>
    </div>

    <div class="table-container">
      <div class="table-header">
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-start position-relative">
          <div class="w-full w-md-auto md-flex-1">
            <div class="d-flex justify-content-between align-items-center justify-content-lg-start">
              <button type="button" class="filter d-flex align-items-center justify-content-between border-0"
                @click="showFilters = !showFilters">
                <i class="ri-filter-3-line text-dark font-weight-bold"></i>
                <div>Filtrar</div>
              </button>
              <div class="d-md-none">
                <button type="button" class="button-tooltip text-dark font-weight-bold m-0" v-b-tooltip.hover
                  title="Recargar" @click="loadData()">
                  <i class="ri-loop-right-line"></i>
                </button>
              </div>
            </div>
          </div>

          <section class="w-full w-md-auto md-flex-1 d-flex justify-content-end align-items-center mt-2 mt-md-0">
            <div class="d-none d-md-flex">
              <button type="button" class="button-tooltip text-dark font-weight-bold" v-b-tooltip.hover
                title="Recargar" @click="loadData()">
                <i class="ri-loop-right-line"></i>
              </button>
            </div>
            <div class="w-full w-md-auto d-flex flex-column flex-md-row">
              <SearchBar placeholder="Buscar por nombre o código" @input="search = $event" class="flex-1" />
              <div class="text-right mt-2 mt-md-0">
                <b-button variant="none" class="button button-primary ml-md-2" @click="openCreate()">Agregar</b-button>
              </div>
            </div>
          </section>

          <filter-menu :show="showFilters" @hide="showFilters = false" :options="filterOptions"
            :selectedOptionFilter="filters" @setFilters="setFilters"></filter-menu>
        </div>

        <div class="w-100 d-flex flex-wrap align-items-center mt-2" v-if="showFiltersList">
          <span v-for="(val, name) in filterList" v-bind:key="name" class="filter-item">
            {{ getFilterName(name, val) }}
            <button type="button" class="text-white p-0 bg-transparent border-0 ml-2" @click="deleteFilter(name)">
              <i class="ri-close-circle-line"></i>
            </button>
          </span>
        </div>
      </div>

      <div class="table-responsive mb-0 table-min-height">
        <table class="custom-table w-100">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Código</th>
              <th>Moneda</th>
              <th>Símbolo</th>
              <th>Zona horaria</th>
              <th class="text-center">Estado</th>
              <th class="pr-md-4">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="o in filteredList" :key="o.id">
              <td>{{ o.name }}</td>
              <td><code>{{ o.code }}</code></td>
              <td>{{ o.currency }}</td>
              <td>{{ o.currency_symbol }}</td>
              <td>{{ o.timezone }}</td>
              <td class="text-center">
                <span :class="`badge ${o.is_active ? 'badge-success' : 'badge-danger'}`">
                  {{ o.is_active ? 'Activo' : 'Inactivo' }}
                </span>
              </td>
              <td class="text-center d_option pr-md-3">
                <DropdownTable>
                  <template slot="dropdown-content">
                    <DropdownItem text="Editar" @click="openEdit(o)" />
                  </template>
                </DropdownTable>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal crear / editar -->
    <b-modal v-model="showEditor" :title="isEditing ? `Editar país: ${form.name}` : 'Nuevo país'" hide-footer>
      <form @submit.prevent="save()">
        <div class="form-group">
          <label class="form-label">Nombre</label>
          <input v-model="form.name" type="text" class="form-control" maxlength="100" required />
        </div>
        <div class="form-group" v-if="!isEditing">
          <label class="form-label">Código ISO</label>
          <input v-model="form.code" type="text" class="form-control text-uppercase" maxlength="3" required
            placeholder="Ej: PE" />
          <small class="text-muted">2 o 3 letras. No se puede modificar luego.</small>
        </div>
        <div class="form-group">
          <label class="form-label">Moneda (ISO)</label>
          <input v-model="form.currency" type="text" class="form-control text-uppercase" maxlength="3" required />
        </div>
        <div class="form-group">
          <label class="form-label">Símbolo</label>
          <input v-model="form.currency_symbol" type="text" class="form-control" maxlength="10" required />
        </div>
        <div class="form-group">
          <label class="form-label">Zona horaria (IANA)</label>
          <input v-model="form.timezone" type="text" class="form-control" maxlength="50" required
            placeholder="America/Lima" />
        </div>
        <div class="form-group" v-if="isEditing">
          <b-form-checkbox v-model="form.is_active">Activo</b-form-checkbox>
        </div>
        <div class="text-right mt-3">
          <b-button variant="none" class="button button-light mr-2" @click="showEditor = false">Cancelar</b-button>
          <b-button variant="none" class="button button-primary" type="submit">Guardar</b-button>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { GeographyService } from '@/core/services'
import {
  Alert,
  Constants,
  DropdownTable,
  DropdownItem,
  SearchBar,
  FilterMenu,
  FilterMixin,
} from 'wize-admin'

export default {
  components: { SearchBar, FilterMenu, DropdownTable, DropdownItem },
  mixins: [FilterMixin],
  data() {
    return {
      list: [],
      search: '',
      showEditor: false,
      isEditing: false,
      form: { id: null, name: '', code: '', currency: '', currency_symbol: '', timezone: '', is_active: true },
      filterOptions: [
        {
          label: 'Estado',
          key: 'is_active',
          type: Constants.TypeFilters.SINGLE,
          options: [
            { key: true, label: 'Activo' },
            { key: false, label: 'Inactivo' },
          ],
        },
      ],
    }
  },
  computed: {
    filteredList() {
      const q = this.search.toLowerCase()
      return this.list.filter(o => {
        const matchSearch = !q || o.name.toLowerCase().includes(q) || o.code.toLowerCase().includes(q)
        const matchStatus = this.filters.is_active == null || o.is_active === this.filters.is_active
        return matchSearch && matchStatus
      })
    },
  },
  methods: {
    openCreate() {
      this.isEditing = false
      this.form = { id: null, name: '', code: '', currency: '', currency_symbol: '', timezone: '', is_active: true }
      this.showEditor = true
    },
    openEdit(o) {
      this.isEditing = true
      this.form = {
        id: o.id,
        name: o.name,
        code: o.code,
        currency: o.currency,
        currency_symbol: o.currency_symbol,
        timezone: o.timezone,
        is_active: o.is_active,
      }
      this.showEditor = true
    },
    async save() {
      try {
        await this.$store.dispatch('app/loading', true)
        if (this.isEditing) {
          await GeographyService.updateCountry(this.form.id, {
            name: this.form.name,
            currency: this.form.currency.toUpperCase(),
            currency_symbol: this.form.currency_symbol,
            timezone: this.form.timezone,
            is_active: this.form.is_active,
          })
          Alert.success('País actualizado correctamente')
        } else {
          await GeographyService.createCountry({
            name: this.form.name,
            code: this.form.code.toUpperCase(),
            currency: this.form.currency.toUpperCase(),
            currency_symbol: this.form.currency_symbol,
            timezone: this.form.timezone,
          })
          Alert.success('País creado correctamente')
        }
        this.showEditor = false
        await this.loadData()
      } catch (ex) {
        console.error(ex)
        Alert.error(ex?.errors?.message || 'Error al guardar el país')
      } finally {
        await this.$store.dispatch('app/loading', false)
      }
    },
    async loadData() {
      try {
        await this.$store.dispatch('app/loading', true)
        const res = await GeographyService.listCountries()
        this.list = res.payload || []
      } catch (e) {
        console.error(e)
        Alert.error(e?.errors?.message || 'Error al cargar los países')
      } finally {
        await this.$store.dispatch('app/loading', false)
      }
    },
  },
  async mounted() {
    await this.loadData()
  },
}
</script>

<style lang="stylus" scoped></style>
